import ActionSelector from '../../components/ActionSelector'
import { useModuleAction } from '../../hooks/useModuleAction'
import AddTokenInfoForm from './AddTokenInfoForm'
import { type TokenInfoAction } from './constants'
import RemoveTokenInfoForm from './RemoveTokenInfoForm'

export default function TokenInfoModule() {
  const { selectedAction, selectAction, isValidAction } =
    useModuleAction('tokeninfo')

  const formByAction = {
    add: AddTokenInfoForm,
    remove: RemoveTokenInfoForm,
  } satisfies Record<TokenInfoAction, React.ComponentType>

  const Form = selectedAction ? formByAction[selectedAction] : null

  if (!isValidAction) {
    return <ActionSelector module='tokeninfo' onSelectAction={selectAction} />
  }

  return <div className='space-y-4'>{Form && <Form />}</div>
}
